import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail, ArrowLeft, Send } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { AuthShell, Field, inputClass } from "@/components/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
      toast.success(data.message || "If the account exists, a reset link has been sent.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Forgot Password"
      subtitle="We'll email you a secure link to reset it"
      footer={<Link to="/login" className="text-amber-300 hover:text-amber-200">Back to Sign In</Link>}
    >
      {sent ? (
        <div className="text-center" data-testid="forgot-sent">
          <Mail size={30} className="mx-auto text-amber-400" />
          <p className="mt-4 text-sm text-slate-300 leading-relaxed">
            If an account exists for <span className="text-amber-200">{email}</span>, a password reset link is on
            its way. The link is valid for 1 hour.
          </p>
          <Link to="/login" className="btn-gold rounded-full px-6 py-2.5 text-sm mt-6 inline-flex items-center gap-2">
            <ArrowLeft size={16} /> Back to Sign In
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <Field label="Email Address">
            <input data-testid="forgot-email-input" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} className={inputClass} placeholder="you@example.com" />
          </Field>
          <button data-testid="forgot-submit-button" type="submit" disabled={loading}
            className="btn-gold rounded-full w-full py-3.5 flex items-center justify-center gap-2 disabled:opacity-60">
            <Send size={18} /> {loading ? "Sending…" : "Send Reset Link"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
